var sharp_GA339WJSA = {
    name: "GA339WJSA",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,171,174,126,183,178],
        },
        {
            function: "I/II/I+II",
            name: "I/II/I+II",
            icon: "I/II/I+II",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,170,245,236,128],
        },
        {
            function: "BACKLIGHT",
            name: "BACKLIGHT",
            icon: "BACKLIGHT",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,207,158,127,106,233],
        },
        {
            function: "ROTATE",
            name: "ROTATE",
            icon: "ROTATE",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,216,154,127,94,178],
        },
        {
            function: "AV+",
            name: "AV+",
            icon: "AV+",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,171,174,125,119,178],
        },
        {
            function: "AV-",
            name: "AV-",
            icon: "AV-",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,180,170,123,175,105],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,162,178,127,111,100],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,189,166,126,218,180,128],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,180,170,125,91,217],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,170,189,236,128],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,162,178,126,239,100],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,171,174,127,182,210],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,170,246,244,128],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,189,166,125,173,180,128],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,180,170,127,173,89],
        },
        {
            function: "BT_END",
            name: "BT_END",
            icon: "BT_END",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,162,178,126,223,164],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,153,182,127,238,200],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,189,166,122,234,244,128],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,171,174,127,107,178],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,207,158,170,191,217],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,153,182,126,254,200],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,170,175,236,128],
        },
        {
            function: "TELETEXT?",
            name: "TELETEXT?",
            icon: "TELETEXT?",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,171,174,127,171,178],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,207,158,170,239,217],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,162,178,125,191,100],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,170,215,236,128],
        },
        {
            function: "FREEZE_HOLD",
            name: "FREEZE_HOLD",
            icon: "FREEZE_HOLD",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,180,170,125,117,217],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,189,166,127,170,180,128],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,153,182,127,190,200],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,170,187,236,128],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [32,0,3,95,1,114,6,95,1,123,2,94,1,198,162,125,174,172,128],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,162,178,126,223,100],
        },
        {
            function: "FLASHBACK",
            name: "FLASHBACK",
            icon: "FLASHBACK",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,180,170,127,173,105],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,162,178,127,187,100],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,189,166,126,181,180,128],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,171,174,126,221,178],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [32,0,3,95,1,123,2,95,1,114,6,94,1,180,170,127,107,105],
        },
    ]
}
export default sharp_GA339WJSA